/*
 * @Author: c.k
 * @Date: 2023-03-07 18:15:05
 * @LastEditors: skq shuke@withsawyer.cn
 * @LastEditTime: 2025-10-27 15:15:50
 * @Descripttion:
 */
module.exports = {
    // 本地测试环境
    development: {
        NODE_ENV: 'development',
        ENV_API: 'https://api.jinliwangluo.com/api',
        ENV_TIME_API: 'https://mcs.jinliwangluo.com/api', // 服务器时间戳接口
        ENV_TRACK_API: 'https://mcs.jinliwangluo.com/api', // 埋点接口
        ENV_CANONICAL: 'http://dev.jinliwangluo.com',
        ENV_BAIDU_URL: 'dev.jinliwangluo.com',
        ENV_RY_KEY: 'pvxdm17jpfwxr',
        ENV_AUTH_RETRUN_URL: 'http://m7-v3.jinliwangluo.com/center/authentication/realPerson/result',
        ENV_H5_URL: 'https://h2.jinliwangluo.com'
    },

    // 开发环境
    dev: {
        NODE_ENV: 'development',
        ENV_API: 'https://api.jinliwangluo.com/api',
        ENV_TIME_API: 'https://mcs.jinliwangluo.com/api', // 服务器时间戳接口
        ENV_TRACK_API: 'https://mcs.jinliwangluo.com/api', // 埋点接口
        ENV_CANONICAL: 'http://dev.jinliwangluo.com',
        ENV_BAIDU_URL: 'dev.jinliwangluo.com',
        ENV_RY_KEY: 'pvxdm17jpfwxr',
        ENV_AUTH_RETRUN_URL: 'http://m7-v3.jinliwangluo.com/center/authentication/realPerson/result',
        ENV_H5_URL: 'https://h2.jinliwangluo.com'
    },
    // 线上测试环境
    test: {
        NODE_ENV: 'test',
        ENV_API: 'https://api.yingbowl.com/api',
        ENV_TIME_API: 'https://mcs.yingbowl.com/api', // 服务器时间戳接口
        ENV_TRACK_API: 'https://mcs.yingbowl.com/api', // 埋点接口
        ENV_CANONICAL: 'http://w.yingbowl.com',
        ENV_BAIDU_URL: 'w.yingbowl.com',
        ENV_RY_KEY: 'pwe86ga5p7vm6',
        ENV_AUTH_RETRUN_URL: 'https://m7-v3.yingbowl.com/center/authentication/realPerson/result',
        ENV_H5_URL: 'https://m7v3.yingbowl.com'
        // NODE_ENV: 'development',
        // ENV_API: 'https://api.jinliwangluo.com/api',
        // ENV_CANONICAL: 'http://dev.jinliwangluo.com',
        // ENV_BAIDU_URL: 'dev.jinliwangluo.com',
        // ENV_RY_KEY: 'pvxdm17jpfwxr',
        // ENV_AUTH_RETRUN_URL: 'http://m7-v3.jinliwangluo.com/center/authentication/realPerson/result',
        // ENV_H5_URL: 'https://h2.jinliwangluo.com'
    },
    /* 生产环境 */
    production: {
        NODE_ENV: 'production',
        ENV_API: 'https://api.pzds.com/api',
        ENV_TIME_API: 'https://mcs.pzds.com/api', // 服务器时间戳接口
        ENV_TRACK_API: 'https://mcs.pzds.com/api', // 埋点接口
        ENV_CANONICAL: 'https://www.pzds.com',
        ENV_BAIDU_URL: 'www.pzds.com',
        ENV_RY_KEY: 'pkfcgjstpew48',
        ENV_AUTH_RETRUN_URL: 'https://m7.pzds.com/center/authentication/realPerson/result',
        ENV_H5_URL: 'https://m7.pzds.com'
    },
    /* 预发环境 */
    pre: {
        NODE_ENV: 'pre',
        ENV_API: 'https://api.pzpre.com/api',
        ENV_TIME_API: 'https://mcs.pzds.com/api', // 服务器时间戳接口
        ENV_TRACK_API: 'https://mcs.pzpre.com/api',
        ENV_CANONICAL: 'https://www.pzpre.com',
        ENV_BAIDU_URL: 'www.pzpre.com',
        ENV_RY_KEY: 'mgb7ka1nm2bvg',
        ENV_AUTH_RETRUN_URL: 'https://h5.pzpre.com/center/authentication/realPerson/result',
        ENV_H5_URL: 'https://h5.pzpre.com'
    }
}
